import React from 'react'
import PropTypes from 'prop-types'
import { Eyebrow as Number } from 'components/Typography'
import {
  CarouselCounter,
  CarouselCounterWrapper,
  CarouselCounterContainer,
} from './CarouselIndicator.style'

const CarouselIndicator = (props) => {
  const { currentSlide, totalSlides, rtl } = props
  const currentNumber = rtl
    ? Math.abs(currentSlide + 1 - totalSlides) + 1
    : currentSlide + 1

  return (
    <CarouselCounter>
      <CarouselCounterWrapper>
        <CarouselCounterContainer>
          <Number>{currentNumber}</Number>
          <Number>{totalSlides}</Number>
        </CarouselCounterContainer>
      </CarouselCounterWrapper>
    </CarouselCounter>
  )
}

CarouselIndicator.propTypes = {
  currentSlide: PropTypes.number.isRequired,
  totalSlides: PropTypes.number.isRequired,
  rtl: PropTypes.bool.isRequired,
}

export default CarouselIndicator
